import { ownershipTenantsInput } from '../Owner';
import { formOwnershipAllocationToFloat, PersonalPropertyItemFormValues } from '../UI';
import { monetaryAmountDataPointValue } from '../DataPoint';
import { MonetaryAmount, PersonalPropertyItem } from '../generated/graphql';
import {
  CreatePersonalPropertyItemServiceInput,
  PersonalPropertyItemFormSubmitData,
  UpdatePersonalPropertyItemValueServiceInput,
  UpdatePersonalPropertyItemServiceInput,
} from './types';

export function getPersonalPropertyItemValue(personalPropertyItem: PersonalPropertyItem): MonetaryAmount | undefined {
  return monetaryAmountDataPointValue(personalPropertyItem.value.latestDataPoint);
}

export function getCreatePersonalPropertyItemServiceInputFromFormValues(
  values: PersonalPropertyItemFormValues & {
    householdID: string;
  }
): CreatePersonalPropertyItemServiceInput {
  return {
    files: values.pendingFiles ?? [],
    valueInCents: values.estimatedValue * 100,
    createPersonalPropertyItemMutationInput: {
      householdID: values.householdID,
      personalPropertyItem: {
        name: values.nickname,
        notes: values.notes,
        ownership: ownershipTenantsInput({
          ownerID: values.ownerData.ownerID,
          ownerType: values.ownerData.ownerType,
          percentage: formOwnershipAllocationToFloat(values.ownershipAllocation),
        }),
      },
    },
  };
}

export function getUpdatePersonalPropertyItemServiceInputFromForm({
  formValues,
  householdID,
  changeToken,
  personalPropertyItemID,
  valueDataPointGroupID,
}: PersonalPropertyItemFormSubmitData): UpdatePersonalPropertyItemValueServiceInput {
  if (!changeToken) throw new Error('changeToken is required');
  if (!householdID) throw new Error('householdID is required');
  if (!personalPropertyItemID) throw new Error('personalPropertyItemID is required');

  return {
    valueInCents: formValues.estimatedValue * 100,
    householdID,
    valueDataPointGroupID,
    personalPropertyItemID,
  };
}

export function getUpdatePersonalPropertyItemServiceInputFromFormFull({
  formValues,
  householdID,
  changeToken,
  personalPropertyItemID,
}: PersonalPropertyItemFormSubmitData): UpdatePersonalPropertyItemServiceInput {
  if (!changeToken) throw new Error('changeToken is required');
  if (!householdID) throw new Error('householdID is required');
  if (!personalPropertyItemID) throw new Error('personalPropertyItemID is required');

  return {
    files: formValues.pendingFiles,
    valueInCents: formValues.estimatedValue * 100,
    updatePersonalPropertyItemInput: {
      changeToken,
      householdID,
      id: personalPropertyItemID,
      changes: {
        name: formValues.nickname,
        notes: formValues.notes,
        ownership: ownershipTenantsInput({
          ownerID: formValues.ownerData.ownerID,
          ownerType: formValues.ownerData.ownerType,
          percentage: formOwnershipAllocationToFloat(formValues.ownershipAllocation),
        }),
      },
    },
  };
}
